module.exports = __webpack_public_path__ + "static/media/Animation - 1720416389083.d52c0946.gif";